import React from 'react';
import LegalLayout, { COMPANY } from './LegalLayout';

const Terms = () => (
  <LegalLayout title="Terms & Conditions" lastUpdated="29 May 2026">
    <p data-testid="terms-intro">
      Welcome to {COMPANY.shortName}. These Terms & Conditions ("Terms") govern your access to and use
      of the {COMPANY.shortName} website, mobile applications, and all related services
      (collectively, the "Platform"). By accessing or using the Platform, you agree to be bound by these Terms.
      If you do not agree, please do not use the Platform.
    </p>

    <h2>1. Definitions</h2>
    <p>
      "Booking" means a confirmed reservation for travel inventory such as flights, hotels, buses,
      packages or any other product offered on the Platform. "Supplier" refers to the underlying
      provider of such inventory (airline, hotel, bus operator, etc.). "User" or "You" refers to any
      individual or entity using the Platform.
    </p>

    <h2>2. Eligibility</h2>
    <p>You must be at least 18 years old and legally capable of entering into binding contracts to
      use the Platform. Corporate accounts must be authorised by the registered organisation.</p>

    <h2>3. Role of {COMPANY.shortName}</h2>
    <p>{COMPANY.shortName} acts as an intermediary technology platform between travellers and
      Suppliers. Each booking is a direct contract between you and the relevant Supplier. We are
      not liable for the acts, errors, omissions or breaches of any Supplier.</p>

    <h2>4. Booking & Payments</h2>
    <ul>
      <li>All prices are quoted in INR unless otherwise stated and include applicable taxes and convenience fees.</li>
      <li>Booking is confirmed only after successful payment realisation and supplier confirmation.</li>
      <li>You are solely responsible for the accuracy of traveller information (name, age, passport, etc.).</li>
      <li>In case of last-mile failure between payment and confirmation, refunds are processed within 7-10 working days.</li>
    </ul>

    <h2>5. Cancellation & Refunds</h2>
    <p>Cancellations are governed by the Supplier's cancellation policy as displayed at the time of
      booking. Service fees charged by {COMPANY.shortName} are non-refundable. See our
      <a href="/refund-policy"> Refund Policy</a> for details.</p>

    <h2>6. User Conduct</h2>
    <p>You agree not to use the Platform for unlawful purposes, fraud, scraping inventory, reverse
      engineering or violating the rights of any third party. We may suspend or terminate accounts
      that breach these Terms.</p>

    <h2>7. Limitation of Liability</h2>
    <p>{COMPANY.shortName}'s aggregate liability for any claim shall not exceed the amount of service
      fees collected by us for the impacted booking. We are not liable for indirect, incidental or
      consequential damages.</p>

    <h2>8. Force Majeure</h2>
    <p>We are not liable for delays or failures caused by events beyond our reasonable control —
      including natural disasters, pandemics, government actions, acts of war or strikes.</p>

    <h2>9. Governing Law & Jurisdiction</h2>
    <p>These Terms are governed by the laws of India. Courts at Bengaluru, Karnataka shall have
      exclusive jurisdiction over any dispute.</p>

    <h2>10. Contact</h2>
    <p>{COMPANY.name}, {COMPANY.address}. Email: {COMPANY.email}. GSTIN: {COMPANY.gstin}.</p>
  </LegalLayout>
);

export default Terms;
